
<template  minapp='mpx' xlang='wxml'>
  <es-drawer-bottom
    title="{{title}}"
    show="{{show}}"
    showDefaultNav
    bind:close="closePriceDetail"
    class="main"
    customStyle="{{curCustomStyle}}"
  >
    <price-detail-card
      hasBottomBar="{{hasBottomBar}}"
      priceDetail="{{priceDetail}}"
      priceDetailCardTip="{{priceDetailCardTip}}"
      bind:close="closePriceDetail"
      studentLength="{{studentLength}}"
    />
  </es-drawer-bottom>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { getFinalPrice } from '@/utils/money'
  import { TrainFeeType } from '@/common/enum'
  import { innerRouter, pagePath } from '@/common/jump'

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: false,
      },
      title: {
        type: String,
        value: '费用明细',
      },
      hasBottomBar: {
        type: Boolean,
        value: false,
      },
      priceDetailCardTip: {
        type: String,
        value: '',
      },
      priceDetail: {},
      customStyle: {},
      studentLength: 0,
    },
    computed: {
      curCustomStyle() {
        return {
          background: '#ffffff',
          height: '570px',
          ...this.customStyle,
        }
      }
    },
    data: {},
    watch: {
      show: {
        immediate: true,
        deep: true,
        handler(old) {
          if (this.show) {
            this.priceDetail?.map?.((item, index) => {
              //第一条不展示
              item.showDetailButton = item?.tip !== '' && index !== 0
              return item
            })
          }
        },
      },
    },
    methods: {
      closePriceDetail() {
        this.$trigger('close', null)
      },
      hideDetailButton(pos) {
        this.priceDetail?.map?.((item, index) => {
          if (pos === index) {
            item.showDetailButton = false
          }
          return item
        })
        this.$forceUpdate()
      },
      goPage(item) {
        this.closePriceDetail()
        switch (item.type) {
          case TrainFeeType.refund:
            this.toRefundPage(item)
            break
          case TrainFeeType.change:
            this.toChangePage(item)
            break
          default:
            break
        }
      },
      toRefundPage(item) {
        innerRouter.push(pagePath().REFUNDTICKETDETAILPAGE, {
          order_id: item.order_id,
          selected_ticket_id: item?.ticket_id,
          from: this.from,
        })
      },
      toChangePage(item) {
        innerRouter.push(pagePath().CHANGETICKETDETAILPAGE, {
          order_id: item.order_id,
          selected_ticket_id: item?.ticket_id,
          from: this.from,
        })
      },
    },
  })
</script>

<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'

  .main
    /deep/ .es-navbar
      background-color $trian-color-background
    /deep/ .drawer-container
      overflow auto
  .rich-text-bold
    font-family PingFangSC-Semibold
    font-size 18px
    letter-spacing 0
    text-align right
    display flex
    align-items center
    color $train-color-theme-blue
    font-weight normal
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom',
      'price-detail-card': '@/components/price-detail-card',
    },
  }
</script>